const smtMenuComponent = {
  item: {
    highlight: {
      default: 'theme.600',
      _dark: 'theme.600'
    },
    focus: {
      bgColor: {
        default: 'theme.100',
        _dark: 'theme.900'
      },
      headingColor: {
        default: 'theme.600',
        _dark: 'theme.600'
      }
    }
  },
  groupTitle: {
    color: {
      default: 'gray.500',
      _dark: 'gray.400'
    }
  },
  noResults: {
    color: {
      default: 'gray.500',
      _dark: 'gray.400'
    }
  }
};

export default smtMenuComponent;
